import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../fonts/Ready.woff2%22,%22style%22:%22normal%22},{%22path%22:%22../fonts/Ready.woff%22,%22style%22:%22normal%22}],%22variable%22:%22--font-ready%22,%22display%22:%22swap%22,%22preload%22:false}],%22variableName%22:%22ready%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'ready', 'ready Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
